<div class="modal-header">
    <div class="row">
        <h4 *ngIf="isNewItem">{{crearPreguntaTexto}}</h4>
        <h4 *ngIf="!isNewItem">{{actualizarPreguntaTexto}}</h4>
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="activeModal.close(null)"></button>
</div>
<div class="modal-body">
    <app-form [fields]="fieldsPregunta" [withSubmitButton]="false" (changeAction)="onChangeForm($event)"
        (submitAction)="onSubmitForm($event)"></app-form>

    <div class="container" *ngIf="fieldType == 'radiobutton'">

        <div class="row mt-5 mb-3">
            <div class="col-md-6">
                <h5 *ngIf="opcionesRespuestaTexto">{{opcionesRespuestaTexto}}:</h5>
            </div>
            <div class="col-md-6">
                <button class="btn-govco outline-btn-govco" style="margin-top: 0;" 
                (click)="addOption()"
                aria-label="Agregar opción">{{agregarOpcion}}
                    <i class="fa fa-plus-square-o" style="margin-top: 3px; margin-left: 5px;" aria-hidden="true"></i>
                </button>
            </div>

        </div>
        <div class="row">
            <form [formGroup]="preguntaForm">
                <div formArrayName="opciones">
                    <div *ngFor="let opcion of opciones.controls; let i = index" [formGroupName]="i">
                        <div class="row align-items-center">
                            <div class="col-md-10">
                                <input type="text" class="form-control" formControlName="Descripcion"
                                    placeholder="{{insertarOpcion}}">
                            </div>
                            <div class="col-md-2 d-flex justify-content-center">
                                <button type="button" class="btn-govco outline-btn-govco" 
                                (click)="removeOption(i)"
                                aria-label="Eliminar opción">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col-md-3 offset-md-9">
            <button 
            class="btn-govco outline-btn-govco"
            [disabled]="validarFormulario()"
            (click)="guardarPreguntas()"
            aria-label="Guardar pregunta">{{guardarText}}</button>
        </div>
    </div>
</div>